import { render, staticRenderFns } from "./PrintReceipt.template.vue?vue&type=template&id=21da2c2b&scoped=true&"
var script = {}
import style0 from "./PrintReceipt.template.vue?vue&type=style&index=0&id=21da2c2b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da2c2b",
  null
  
)

export default component.exports